<template>
  <div class="tpl-bd">
    <custom-dialog :title="model.title" :visible="visible" v-on="$listeners" width="500px">
      <div class="dialog-body">
        <el-form :model="form" ref="form">
          <el-row>
            <el-col :span="24">
              <el-form-item label="RFID" prop="rfid" :rules="rules.rfid">
                <el-input v-model="form.rfid" placeholder="" :disabled="!!related"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('dms_bootCard_item_dialog.ka_mian_bian_hao')" prop="cardNum" :rules="rules.cardNum">
                <el-input v-model="form.cardNum" placeholder="" :disabled="!!related"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('dms_bootCard_item_dialog.yan_se')" prop="cardColor" :rules="rules.cardColor">
                <custom-select v-model="form.cardColor" code="dms_boot_card_color" :disabled="!!related"></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('Common.com_status')" prop="state" :rules="rules.state">
                <custom-select v-model="form.state" code="dms_boot_card_state"></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('Common.com_remark')" prop="cardDesc" :rules="rules.cardDesc">
                <el-input type="textarea" :rows="5" v-model="form.cardDesc" placeholder=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">
          {{ $t('Common.com_cancel') }}
        </el-button>
        <el-button type="primary" @click="saveBootCard">
          {{ $t('Common.com_confirm') }}
        </el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      related: false,
      form: {
        cardColor: '',
        cardDesc: '',
        cardId: '',
        cardNum: '',
        rfid: '',
        state: '',
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        rfid: [
          {
            required: true,
            message: this.$t('dms_bootCard_item_dialog.qing_shu_ruRFID'),
          },
          {
            max: 30,
            message: this.$t('Common.com_rules_length_max', [30]),
          },
        ],
        cardNum: [
          {
            required: true,
            message: this.$t('dms_bootCard_item_dialog.qsrkmbh'),
          },
          {
            max: 30,
            message: this.$t('Common.com_rules_length_max', [30]),
          },
        ],
        cardColor: [
          {
            required: true,
            message: this.$t('dms_bootCard_item_dialog.qing_xuan_ze_yan_se'),
          },
        ],
        state: [
          {
            required: true,
            message: this.$t('dms_bootCard_item_dialog.qxzzt'),
          },
        ],
        cardDesc: [
          {
            max: 200,
            message: this.$t('Common.com_rules_length_max', [200]),
          },
        ],
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      if (this.model.type === 'edit') {
        this.form.cardId = this.model.cardId;
        this.getBootCardInfo();
      }
    },

    getBootCardInfo: function () {
      this.$getJSON(apis.bootCardInfo, { cardId: this.model.cardId }).then((res) => {
        this.form = res.data;
        this.form.state = `${res.data.state}`;
        // 设备关联
        this.related = (res.data.deviceCard && res.data.deviceCard.bodyNum) || false;
      });
    },
    // 确认保存菜单
    saveBootCard: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.saveEditBootCard();
      });
    },
    // 保存编辑分组
    saveEditBootCard: function () {
      this.$postJSON(apis.bootCardUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
};
</script>

<style lang="scss"></style>
